<!-- Save Report popup start here -->
<div>
    <p-drawer [header]="generateReportTitle" [(visible)]="generateReportFormVisible" position="right"
        [style]="{width: popupWidth}" (onHide)="hideGenerateReportForm()" (onShow)="ngOnViewInit()">
        <form [formGroup]="reportForm">
            <div class="grid" [ngClass]="{'hidden': !(saveReportFields || showAllFields)}">
                <div class="field col-4 inptLP">
                    <label>Report Name</label>
                    <input type="text" pInputText formControlName="reportName" placeholder="Report Name"
                        class="w-full" />
                    <small class="p-error" style="font-size:12px"
                        *ngIf="reportForm.get('reportName')?.invalid && reportForm.get('reportName')?.touched">
                        Report name is required
                    </small>
                </div>
                <div class="field col-8 pl-0">
                    <label>Report Description</label>
                    <input type="text" pInputText formControlName="reportDesc" class="w-full"
                        placeholder="Report Description" />
                    <small class="p-error" style="font-size:12px"
                        *ngIf="reportForm.get('reportDesc')?.invalid && reportForm.get('reportDesc')?.touched">
                        Description is required
                    </small>
                </div>
            </div>
            <div class="grid sectBr" [ngClass]="{'hidden': !(reportModuleFields || showAllFields)}">
                <div class="field col-4 inptLP">
                    <label>Choose Business Unit</label>
                    <p-multiSelect formControlName="businessUnitIds" [default]="selectedBusinessUnitList"
                        optionValue="code" [options]="getAccessibleBusinessUnitList()" optionLabel="name"
                        placeholder="Choose Business Unit" [showClear]="true" [showToggleAll]="true" [filter]="true"
                        class="w-full" appendTo="body" (onChange)="onBusinessUnitIdsChange($event)" />
                    <small style="font-size:12px" class="p-error"
                        *ngIf="reportForm.get('businessUnitIds')?.invalid && reportForm.get('businessUnitIds')?.touched">
                        Business unit is required
                    </small>
                </div>
                <div class="field col-4 inptLP pl-0">
                    <label>Choose Module</label>
                    <p-select formControlName="reportId" [options]="getModulesList()" optionLabel="name"
                        optionValue="code" placeholder="Choose Module" [showClear]="!showAllFields" [filter]="true"
                        [checkmark]="true" (onChange)="moduleChanged($event)" class="w-full"
                        [readonly]="showAllFields" appendTo="body" />
                         <!-- Don't remove this attribute [readonly]="showAllFields" -->
                    <small class="p-error" style="font-size:12px"
                        *ngIf="reportForm.get('reportId')?.invalid && reportForm.get('reportId')?.touched">
                        Module is required
                    </small>
                </div>
                <div class="field col-4 pl-0">
                    <label>Choose Report Type</label>
                    <p-select formControlName="reportType" [options]="reportTypes" optionLabel="name" optionValue="code"
                  placeholder="Choose Report Type" [showClear]="!showAllFields" [filter]="true" [checkmark]="true"
                        (onChange)="reportTypeChanged($event)" class="w-full" [readonly]="isReportAlreadySaved()" appendTo="body" />
                    <small class="p-error" style="font-size:12px"
                        *ngIf="reportForm.get('reportType')?.invalid && reportForm.get('reportType')?.touched">
                        Report type is required
                    </small>
                </div>
            </div>
            <div class="flex"
                *ngIf="reportForm.get('reportId')?.value && reportForm.get('reportId')?.value != '' && reportForm.get('reportId')?.value != null && reportForm.get('reportType')?.value != null">
                <div [ngClass]="{'hidden': !showColumnsPopup, 'pdR sectCol': (showAllFields || reportModuleFields), 'pdL': (reportModuleFields && !showColumnsPopup)}"
                    class="{{chooseColumnsClass}}  pl-0 pb-0 pt-0 ">
                    <div *ngIf="reportForm.get('reportId')?.value == '9'">
                        <div class="mb-3">
                            <div class="flex align-items-center mt-3">
                                <label class="mr-3">Type</label>
                                <div class="field-radiobutton mr-3 mb-0">
                                    <p-radioButton value={{filterType.ROLE}} formControlName="filterType"
                                        (click)="onFilterTypeChange({value: filterType.ROLE})"
                                        inputId="filterTypeRole"></p-radioButton>
                                    <label for="filterTypeRole">Role</label>
                                </div>
                                <div class="field-radiobutton mb-0"
                                    *ngIf="teamsAndRolesResponse.teamData.teamNames.length > 0">
                                    <p-radioButton value={{filterType.TEAM}} formControlName="filterType"
                                        (click)="onFilterTypeChange({value: filterType.TEAM})"
                                        inputId="filterTypeTeam"></p-radioButton>
                                    <label for="filterTypeTeam">Teams</label>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" *ngIf="reportForm.get('filterType')?.value == filterType.ROLE">
                            <div class="field">
                                <div class="mb-3">
                                    <div class="field">
                                        <label>Select Role</label>
                                        <p-select [options]="teamsAndRolesResponse.roles" optionLabel="name"
                                            optionValue="code" formControlName="filterRole" placeholder="Select Role"
                                            class="w-full" (onChange)="onFilterRoleChange($event)" appendTo="body" />
                                        <small style="font-size:12px" class="p-error"
                                            *ngIf="reportForm.get('filterRole')?.invalid && reportForm.get('filterRole')?.touched">
                                            Role is required
                                        </small>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="field">
                                        <label>Role Users</label>
                                        <p-multiselect [options]="getRoleWiseUsersList()" optionValue="code"
                                            optionLabel="name" formControlName="roleUserIds"
                                            placeholder="Select Role Users" class="w-full" appendTo="body" />
                                        <small style="font-size:12px" class="p-error"
                                            *ngIf="reportForm.get('roleUserIds')?.invalid && reportForm.get('roleUserIds')?.touched">
                                            Role users are required
                                        </small>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="mb-3" *ngIf="reportForm.get('filterType')?.value == filterType.TEAM">
                            <div class="field">
                                <div class="mb-3">
                                    <div class="field">
                                        <label>Select Team</label>
                                        <p-multiselect [options]="teamsAndRolesResponse.teamData.teamNames"
                                            optionLabel="name" formControlName="teamList" optionValue="code"
                                            placeholder="Select Teams" class="w-full" appendTo="body"
                                            (onChange)="onTeamListChange()" />
                                        <small style="font-size:12px" class="p-error"
                                            *ngIf="reportForm.get('teamList')?.invalid && reportForm.get('teamList')?.touched">
                                            Team is required
                                        </small>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="field">
                                        <label>Team Members</label>
                                        <p-multiselect formControlName="teamMembersList" [options]="getTeamMembers()"
                                            optionLabel="name" optionValue="code" placeholder="Select Team Members"
                                            class="w-full" appendTo="body" />
                                        <small style="font-size:12px" class="p-error"
                                            *ngIf="reportForm.get('teamMembersList')?.invalid && reportForm.get('teamMembersList')?.touched">
                                            Team members are required
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="[14, 16, 36].includes(+reportForm.get('reportId')?.value)">
                        <div class="mb-3">
                            <div class="field">
                                <div class="mb-3">
                                    <div class="field">
                                        <label>Select Team</label>
                                        <p-multiselect [options]="teamsAndRolesResponse.teamData.teamNames"
                                            optionLabel="name" formControlName="teamList" optionValue="code"
                                            placeholder="Select Teams" class="w-full" appendTo="body"
                                            [showClear]="true" (onChange)="onTeamListChange()" />
                                        <small style="font-size:12px" class="p-error"
                                            *ngIf="reportForm.get('teamList')?.invalid && reportForm.get('teamList')?.touched">
                                            Team is required
                                        </small>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="field">
                                        <label>Team Members</label>
                                        <p-multiselect formControlName="teamMembersList" [options]="getTeamMembers()"
                                            optionLabel="name" optionValue="code" placeholder="Select Team Members"
                                            class="w-full" appendTo="body" [showClear]="true" />
                                        <small style="font-size:12px" class="p-error"
                                            *ngIf="reportForm.get('teamMembersList')?.invalid && reportForm.get('teamMembersList')?.touched">
                                            Team members are required
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="reportForm.get('reportId')?.value == '20'">
                        <div class="mb-3 ">
                            <div class="field">
                                <label>Placement Report On</label>
                                <p-multiselect [options]="placementReportOptions" optionLabel="name" optionValue="code"
                                    placeholder="Choose Placement Report On" class="w-full"
                                    formControlName="placementReportOn" appendTo="body" />
                            </div>
                        </div>
                        <ng-container *ngIf="reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT">
                            <div class="mb-3">
                                <div class="field">
                                    <p-checkbox [inputId]="'currencyConversion'" formControlName="currencyConversion"
                                        [binary]="true" />
                                    <label for="currencyConversion" class="ml-2">Currency Conversion</label>
                                </div>
                            </div>
                            <div class="mb-3" *ngIf="reportForm.get('currencyConversion')?.value">
                                <div class="field">
                                    <label>Choose Currency</label>
                                    <p-select [options]="currencyList" optionLabel="name" optionValue="code"
                                        placeholder="Choose Currency" class="w-full" formControlName="currencyDetails" appendTo="body" />
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div *ngIf="reportForm.get('reportId')?.value == '5'">
                        <div class="mb-3">
                            <div class="field">
                                <label>Marketing Status</label>
                                <p-multiselect [options]="talentBenchActiveStatus" optionLabel="name" optionValue="code"
                                    placeholder="Choose Marketing Status" class="w-full"
                                    formControlName="marketingStatus" appendTo="body" />
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="field">
                                <label>Bench Status</label>
                                <p-multiselect [options]="talentBenchReportOptions.statuses" optionLabel="name"
                                    optionValue="code" placeholder="Choose Bench Status" class="w-full"
                                    formControlName="benchStatus" appendTo="body" />
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="field">
                                <label>Bench Sub Status</label>
                                <p-multiselect [options]="getBenchSubStatus()" optionLabel="name" optionValue="code"
                                    placeholder="Choose Bench Sub Status" class="w-full"
                                    formControlName="benchSubStatus" appendTo="body" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="+reportForm.get('reportId')?.value === 110">
                        <div class="mb-3">
                            <div class="field">
                                <label>Choose Users</label>
                                <p-multiselect [options]="usersListOptions" optionLabel="name" optionValue="code"
                                    placeholder="Select Users" styleClass="w-full md:w-80" formControlName="usersList"
                                    [selectionLimit]="10" [maxSelectedLabels]="3" [showToggleAll]="true"
                                    [showClear]="true" [filter]="true" (onChange)="onUsersListChange($event)"
                                    appendTo="body" />
                            </div>
                        </div>
                    </div>

                    <div class="mb-3"
                        *ngIf="[ReportType.SUMMARY_REPORT, ReportType.DIMENSION_REPORT, ReportType.GRAPH_REPORT].includes(+reportForm.get('reportType')?.value)">

                        <div class="sectLab1 mb-3" *ngIf="!showColumnsPopup">Columns</div>
                        <div class="field marB-10">
                            <label
                                *ngIf="[ReportType.SUMMARY_REPORT, ReportType.DIMENSION_REPORT].includes(+reportForm.get('reportType')?.value)">Group
                                Columns</label>
                            <label *ngIf="reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT">X-Axis</label>
                            <p-multiselect [options]="groupByFilters" optionLabel="name" optionValue="code"
                                placeholder="Select Columns" [maxSelectedLabels]="3" styleClass="w-full md:w-80"
                                formControlName="groupByFilters" [selectionLimit]="3" [showToggleAll]="false"
                                [showClear]="true" [filter]="true" [selectedItems]="selectedGroupByFilters"
                                (onChange)="onGroupByFiltersChange($event)" appendTo="body" />
                            <small style="font-size:12px" class="p-error"
                                *ngIf="reportForm.get('groupByFilters')?.invalid && reportForm.get('groupByFilters')?.touched">
                                <span
                                    *ngIf="reportForm.get('reportType')?.value == ReportType.SUMMARY_REPORT || reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT">Group</span>
                                <span
                                    *ngIf="reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT">X-Axis</span>
                                columns are
                                required
                            </small>
                        </div>
                        <!-- Custom display for Group By Filters -->
                        <div class="OrdList"
                            *ngIf="reportForm.get('groupByFilters')?.value && reportForm.get('groupByFilters')?.value.length > 0">
                            <div class="">
                                <div class="field mb-0">
                                    <label>Group By Columns</label>
                                </div>
                                <div *ngFor="let option of getSafeGroupByFilters(); let i = index"
                                    class="flex w-full align-items-center pListing" draggable="true"
                                    (dragstart)="onDragStart($event, i, 'groupByFilters')" (dragend)="onDragEnd($event)"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event, i, 'groupByFilters')" style="cursor: move;">

                                    <!-- Display Mode -->
                                    <div *ngIf="editingItemCode !== option" class="flex w-full align-items-center">
                                        <div class="mr-2"><img src="assets/images/v-dotts.svg" alt=""></div>
                                        <div class="flex-1">{{ getColumnInfo(option)?.columnName || 'Unknown Column' }}
                                        </div>
                                        <div class="ordLAct">
                                            <a *ngIf="showAllFields" class="cursor-pointer"
                                                (click)="startEditing(option, getColumnInfo(option)?.columnName)">
                                                <i class="pi pi-pencil"></i>
                                            </a>
                                            <a class="cursor-pointer" (click)="removeGroupByFilter(option)">
                                                <i class="pi pi-times"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <!-- Edit Mode -->
                                    <div *ngIf="editingItemCode === option"
                                        class="field flex w-full align-items-center ordLEdit mb-0">
                                        <input type="text" id="editColumn_{{option}}" pInputText class="w-full"
                                            [(ngModel)]="editColumn" [ngModelOptions]="{standalone: true}"
                                            (keyup.enter)="updateItemName(option, editColumn)"
                                            (keyup.escape)="stopEditing()" />
                                        <div class="ordLAct">
                                            <a class="cursor-pointer" (click)="updateItemName(option, editColumn)">
                                                <i class="pi pi-save"></i>
                                            </a>
                                            <a class="cursor-pointer" (click)="stopEditing()">
                                                <i class="pi pi-times"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT">
                        <div class="field marB-10">
                            <label>Dimension Column</label>
                            <p-select [options]="dimensionColumns" optionValue="code" optionLabel="name"
                                placeholder="Dimension Column" styleClass="w-full md:w-80"
                                formControlName="dimensionColumnId" [showClear]="true" [filter]="true"
                                (onChange)="dimensionColumnChanged($event)" appendTo="body" />
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="sectLab1 mb-3"
                            *ngIf="reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT && !showColumnsPopup">
                            Columns</div>

                        <div class="field marB-10" [ngClass]="{'hidden': reportForm.get('reportId')?.value == 109 || reportForm.get('reportId')?.value == 110}">
                            <label *ngIf="reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT">Y-Axis</label>
                            <label *ngIf="reportForm.get('reportType')?.value != ReportType.GRAPH_REPORT">Choose Columns </label>
                            <div
                                *ngIf="reportForm.get('reportType')?.value == ReportType.SUMMARY_REPORT || reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT">
                                <p-multiselect [options]="getGroupByColumns()" optionLabel="name" optionValue="code"
                                    placeholder="Select Columns" styleClass="w-full md:w-80" formControlName="columns"
                                    [maxSelectedLabels]="3" [maxSelectedItems]="3" [showToggleAll]="true"
                                    [showClear]="true" [filter]="true" [selectedItems]="selectedColumns" appendTo="body" />
                            </div>
                            
                            <div *ngIf="reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT">
                                <p-multiselect [options]="getChooseColumns()" optionValue="code" optionLabel="name"
                                    placeholder="Select Columns" styleClass="w-full md:w-80" formControlName="columns"
                                    [maxSelectedLabels]="3" [showToggleAll]="true" [showClear]="true" [filter]="true"
                                    [selectedItems]="selectedColumns" appendTo="body"/>
                            </div>
                            <div *ngIf="reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT">
                                <p-multiselect [options]="dimensionColumnsOptions" optionValue="code" optionLabel="name"
                                    placeholder="Select Columns" styleClass="w-full md:w-80" formControlName="columns"
                                    [maxSelectedLabels]="20" [selectionLimit]="20" [showToggleAll]="true" [showClear]="true" [filter]="true"
                                    [selectedItems]="selectedColumns" appendTo="body"/>
                            </div>
                            <small style="font-size:12px" class="p-error"
                                *ngIf="reportForm.get('columns')?.invalid && reportForm.get('columns')?.touched">
                                <span
                                    *ngIf="reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT">Y-Axis columns are required</span>
                                    <span *ngIf="reportForm.get('reportType')?.value !== ReportType.GRAPH_REPORT">Columns are required</span>
                                   
                            </small>
                        </div>
                        <!-- Custom display for Columns with editing -->
                        <div class="OrdList sCol"
                            *ngIf="reportForm.get('columns')?.value && reportForm.get('columns')?.value.length > 0" [ngClass]="{'hidden': reportForm.get('reportId')?.value == 109 || reportForm.get('reportId')?.value == 110}">
                            <div class="">
                                <div class="field mb-0">
                                    <label>Columns</label>
                                </div>
                                <div *ngFor="let option of getSafeColumnsForOrderList(); let i = index"
                                    class="flex w-full align-items-center pListing" draggable="true"
                                    (dragstart)="onDragStart($event, i, 'columns')" (dragend)="onDragEnd($event)"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event, i, 'columns')" style="cursor: move;">
                                    <!-- Display Mode -->
                                    <div *ngIf="editingItemCode !== option" class="flex w-full align-items-center">
                                        <div class="mr-2"><img src="assets/images/v-dotts.svg" alt=""></div>
                                        <div class="flex-1">{{ getColumnInfo(option)?.columnName || 'Unknown Column' }}
                                        </div>
                                        <div class="ordLAct">
                                            <a class="cursor-pointer"
                                                (click)="startEditing(option, getColumnInfo(option)?.columnName)" *ngIf="showAllFields">
                                                <i class="pi pi-pencil"></i>
                                            </a>
                                            <a class="cursor-pointer" (click)="removeColumn(option)">
                                                <i class="pi pi-times"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <!-- Edit Mode -->
                                    <div *ngIf="editingItemCode === option"
                                        class="field flex w-full align-items-center ordLEdit mb-0">
                                        <input type="text" id="editColumn_{{option}}" pInputText class="w-full"
                                            [(ngModel)]="editColumn" [ngModelOptions]="{standalone: true}"
                                            (keyup.enter)="updateItemName(option, editColumn)"
                                            (keyup.escape)="stopEditing()" />
                                        <div class="ordLAct">
                                            <a class="cursor-pointer" (click)="updateItemName(option, editColumn)">
                                                <i class="pi pi-save"></i>
                                            </a>
                                            <a class="cursor-pointer" (click)="stopEditing()">
                                                <i class="pi pi-times"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="reportForm.get('reportId')?.value == 109 || reportForm.get('reportId')?.value == 110">
                        <div class="field marB-10">
                            <label>Choose Status Columns</label>
                            <p-multiselect [options]="stages" optionValue="code" optionLabel="name"
                                placeholder="Select Stage Columns" styleClass="w-full md:w-80" formControlName="stages"
                                [maxSelectedLabels]="3" [showToggleAll]="true" [showClear]="true" [filter]="true"
                                [selectedItems]="selectedStages" appendTo="body" />
                        </div>
                        <div class="OrdList sCol"
                            *ngIf="reportForm.get('stages')?.value && reportForm.get('stages')?.value.length > 0">
                            <div class="">
                                <div class="field mb-0">
                                    <label>Status Columns</label>
                                </div>
                                <div *ngFor="let option of getSafeStagesForOrderList(); let i = index"
                                    class="flex w-full align-items-center pListing" draggable="true"
                                    (dragstart)="onDragStart($event, i, 'stages')" (dragend)="onDragEnd($event)"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event, i, 'stages')" style="cursor: move;">
                                    <div class="flex w-full align-items-center">
                                        <div class="mr-2"><img src="assets/images/v-dotts.svg" alt=""></div>
                                        <div class="flex-1">{{ getStageInfo(option)?.name || 'Unknown Stage' }}</div>
                                        <div class="ordLAct">
                                            <a class="cursor-pointer" (click)="removeStage(option)">
                                                <i class="pi pi-times"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT">
                        <div class="field">
                            <label>Choose Group By Level</label>
                            <p-select appendTo="body" [options]="groupByLevelOptions" optionValue="code" optionLabel="name"
                                placeholder="Select Group By Level" styleClass="w-full md:w-80"
                                formControlName="groupByLevel" [showClear]="true" />
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT">
                        <div class="field">
                            <label>Choose Default Graph Type</label>
                            <p-select appendTo="body" [options]="getGraphTypeOptions()" optionLabel="name"
                                placeholder="Select Graph Type" styleClass="w-full md:w-80"
                                formControlName="defaultGraphType" optionValue="code" optionLabel="name" [showToggleAll]="true" [showClear]="true" />
                        </div>
                    </div>
                    <div class="mb-0">
                        <div class="field mb-0">
                            <label>Choose Sort Columns</label>
                            <p-multiselect [options]="sortColumns" optionLabel="name" placeholder="Select Columns"
                                [maxSelectedLabels]="3" [selectionLimit]="3" styleClass="w-full md:w-80" formControlName="sortColumns"
                                [showToggleAll]="true" [showClear]="true" [selectedItems]="selectedSortColumns" appendTo="body" />
                        </div>
                        <!-- Custom display for Sort Columns -->
                        <div class="OrdList"
                            *ngIf="reportForm.get('sortColumns')?.value && reportForm.get('sortColumns')?.value.length > 0">
                            <div class="field mt-3">
                                <label>Sort Columns</label>
                                <div *ngFor="let option of getSafeSortColumns(); let i = index"
                                    class="flex w-full align-items-center pListing" draggable="true"
                                    (dragstart)="onDragStart($event, i, 'sortColumns')" (dragend)="onDragEnd($event)"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event, i, 'sortColumns')" style="cursor: move;">

                                    <div class="mr-2"><img src="assets/images/v-dotts.svg" alt=""></div>
                                    <div class="flex-1">
                                        <div>{{ option.name || 'Unknown Column' }}</div>
                                    </div>
                                    <div class="ml-auto mr-3 blTxt">
                                        <a href="javascript:void(0)" style="cursor: pointer;" (click)="sortColumn(option)">
                                            <i *ngIf="option.sortOrder == 'ASC'" class="pi pi-sort-alpha-down"></i>
                                            <i *ngIf="option.sortOrder == 'DESC'" class="pi pi-sort-alpha-up"></i>
                                        </a>
                                    </div>
                                    <div class="ordLAct">
                                        <a class="cursor-pointer" (click)="removeSortColumn(option)">
                                            <i class="pi pi-times"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'hidden': !showFiltersPopup, 'pdR1 pdL sectCol': (showAllFields && reportModuleFields), 'pdL': reportModuleFields}"
                    class="{{applyFiltersClass}} p-0">
                    <div class="mb-3 cleCheck" *ngIf="preDefinedFilterOptions.length > 0">
                        <div class="sectLab1 mb-2" *ngIf="(!showFiltersPopup || showAllFields)">Filters</div>
                        <div class="sectLab2 mb-3">Please choose from below predefined filters</div>
                        <!-- <div class="field mb-0 pt-2">
                            <label>Please choose from below predefined filters</label>
                        </div> -->
                        <div formArrayName="preDefinedFilters">
                            <div *ngFor="let category of preDefinedFilterOptions; let i = index"
                                class="flex items-center grpLi"
                                [ngClass]="{'active': preDefinedFiltersArray.at(i).value==category.code || (formData && formData.preDefinedFilters && formData.preDefinedFilters.includes(category.code))}">
                                <p-checkbox [inputId]="'preDefinedFilters'+category.code" [formControlName]="i"
                                    class="round-check" [binary]="false" [value]="category.code" [checked]="true" />
                                <label [for]="'preDefinedFilters'+category.code" class="ml-2"> {{ category.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="field col-10 p-0 mb-2" [ngClass]="{'hidden': checkMarketTypeDisplay()}">
                        <div class="field mb-0">
                            <label>Choose Market <a class="m-0" href="javascript:void(0)" tooltipStyleClass="midTT"
                                pTooltip="Note: The market type cannot be changed once the report is generated."
                                tooltipPosition="bottom"><img src="assets/images/info-icon.svg" alt="" /></a></label>
                        </div>
                        <p-select (onChange)="instanceTypeChanged($event)" formControlName="instanceType" [options]="instanceTypeOptions" optionLabel="name" optionValue="code"
                            placeholder="Choose Market" class="w-full" appendTo="body"/>
                    </div>
                    <div class="field col-10 p-0 mb-2" *ngIf="(showFiltersPopup && !reportModuleFields && !showAllFields)">
                        <div class="field mb-0">
                            <label>Choose Business Units</label>
                        </div>
                        <p-multiSelect formControlName="businessUnitIds" [default]="selectedBusinessUnitList"
                            optionValue="code" [options]="getAccessibleBusinessUnitList()" optionLabel="name"
                            placeholder="Choose Business Unit" [showClear]="true" [showToggleAll]="true" [filter]="true"
                            class="w-full" appendTo="body" (onChange)="onBusinessUnitIdsChange($event)" />
                        <small style="font-size:12px" class="p-error"
                            *ngIf="reportForm.get('businessUnitIds')?.invalid && reportForm.get('businessUnitIds')?.touched">
                            Business unit is required
                        </small>
                    </div>
                    <div class="field col-10 p-0 mb-0">
                        <div class="field mb-0">
                            <label>Choose Period</label>
                        </div>
                        <div class="grid align-items-center">
                            <div class="field col-6 mb-0 pb-0" *ngIf="dateTypeFilters.length > 0">
                                <p-select [filter]="true" [showClear]="false" [options]="dateTypeFilters"
                                    optionLabel="name" optionValue="code" placeholder="Date Filter" class="w-full"
                                    formControlName="dateFilterCol" appendTo="body" />
                            </div>
                            <div class="field col-6 mb-0 pb-0" *ngIf="periodValues.length > 0">
                                <p-select [filter]="true" [showClear]="false" [options]="periodValues"
                                    optionLabel="name" optionValue="code" placeholder="Period" class="w-full"
                                    formControlName="periodValue" appendTo="body" />
                            </div>
                            <div class="field flex align-items-center mb-0"
                                *ngIf="+reportForm.get('periodValue')?.value == 10">
                                <div class="col-6 pt-2 pb-0 pr-2 pl-2">
                                    <p-datePicker appendTo="body" [dateFormat]="defaultDateFormat" formControlName="custStartDate"
                                        [showIcon]="true" placeholder="Start Date" [showButtonBar]="true" 
                                        class="w-full" (onSelect)="onStartDateSelect($event)">
                                    </p-datePicker>
                                    <small style="font-size:12px" class="p-error block" 
                                        *ngIf="reportForm.get('custStartDate')?.invalid && 
                                               (reportForm.get('custStartDate')?.dirty || reportForm.get('custStartDate')?.touched)">
                                        Start Date is required
                                    </small>
                                </div>
                                <div class="col-6 pt-2 pb-0 pr-2 pl-2">
                                    <p-datePicker appendTo="body" [dateFormat]="defaultDateFormat" formControlName="custEndDate"
                                        [showIcon]="true" placeholder="End Date" [showButtonBar]="true" class="w-full" 
                                        [minDate]="reportForm.get('custStartDate')?.value" [maxDate]="maxEndDate">
                                    </p-datePicker>
                                    <small style="font-size:12px" class="p-error block" 
                                        *ngIf="reportForm.get('custEndDate')?.invalid && 
                                               (reportForm.get('custEndDate')?.dirty || reportForm.get('custEndDate')?.touched)">
                                        End Date is required
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-10 p-0 pt-2 mb-0" *ngIf="reportForm.get('reportId')?.value && reportForm.get('reportId')?.value == 6">
                        <div class="field mb-0 flex align-items-center">
                            <p-toggleswitch formControlName="includePipelines" class="mr-2" />
                            <label>Include Pipelines</label>
                        </div>
                    </div>
                    <div class="field mb-0 pt-2">
                        <label>Choose the custom filters below</label>
                    </div>
                    <div class="field col-12 pl-0 pr-0 mb-0 pt-0" formArrayName="filters">
                        <div *ngFor="let filter of filtersFormArray.controls; let i = index" [formGroupName]="i"
                            class="mb-0">
                            <div class="field" *ngIf="i > 0">
                                <div class="flex align-items-center mt-3">
                                    <div class="field-radiobutton mr-3 mb-0">
                                        <p-radioButton name="filterCondition{{i}}" value="AND"
                                            [formControlName]="'filterCondition'+i"
                                            inputId="filterCondition{{i}}AND"></p-radioButton>
                                        <label for="filterCondition{{i}}AND">AND</label>
                                    </div>
                                    <div class="field-radiobutton mb-0">
                                        <p-radioButton name="filterCondition{{i}}" value="OR"
                                            [formControlName]="'filterCondition'+i"
                                            inputId="filterCondition{{i}}OR"></p-radioButton>
                                        <label for="filterCondition{{i}}OR">OR</label>
                                    </div>
                                </div>
                            </div>
                            <div class="grid">
                                <div class="field col-5 mb-0 pb-0">
                                    <p-select [options]="allFilters" optionLabel="name" optionValue="code"
                                        placeholder="Select Column" class="w-full" [filter]="true" [showClear]="false"
                                        formControlName="columnId" (onChange)="updateColumnTypeFilters(i)" appendTo="body" />
                                    <small class="p-error" style="font-size:12px" *ngIf="filter.get('columnId')?.invalid && filter.get('columnId')?.touched">
                                        Column is required
                                    </small>
                                </div>
                                <div class="field col-5 mb-0 pb-0">
                                    <p-select [options]="getColTypeFilters(i)" optionLabel="name"
                                        placeholder="Select Condition" class="w-full" optionValue="code"
                                        formControlName="dataType" (onChange)="updateFilterDropdownOptions(i)" appendTo="body" />
                                    <small class="p-error" style="font-size:12px" *ngIf="filter.get('dataType')?.invalid && filter.get('dataType')?.touched">
                                        Condition is required
                                    </small>
                                </div>
                                <div class="field col-2 mb-0 inline-flex align-items-center" appendTo="body">
                                    <a class="text-decoration-none cursor-pointer" (click)="removeFilter(i)"><i
                                            class="pi pi-trash delRed"></i></a>

                                </div>
                                <div class="field col-10 mb-0"
                                    *ngIf="filter.value.columnId && filter.value.dataType && filter.value.dataType != 3 && filter.value.dataType != 4">
                                    <div class="col-12 pl-0 pr-0 mb-0"
                                        *ngIf="[1,2].includes(getColumnInfo(filter.value.columnId).colDataType)">
                                        <input placeholder="" class="w-full" type="text" formControlName="value"
                                            pInputText>
                                    </div>
                                    <div
                                        *ngIf="([3,6].includes(getColumnInfo(filter.value.columnId).colDataType) && (filter.value.dataType) < 17)">
                                        <div class="field flex align-items-center mb-0"
                                            *ngIf="(filter.value.dataType == 13 || filter.value.dataType == 14)">
                                            <div class="col-6 pt-0 pb-0 pr-2 pl-0">
                                                <p-datePicker appendTo="body" [dateFormat]="defaultDateFormat"
                                                    formControlName="startDate" [showIcon]="true" 
                                                    (onSelect)="onFilterStartDateSelect($event, i)"
                                                    placeholder="Start Date" [showButtonBar]="true" class="w-full">
                                                </p-datePicker>
                                            </div>
                                            <div class="pt-0 pb-0 pl-2 pr-0">
                                                <p-datePicker appendTo="body" [dateFormat]="defaultDateFormat" formControlName="endDate"
                                                    [showIcon]="true" placeholder="End Date" [showButtonBar]="true" 
                                                    [minDate]="getFilterMinEndDate(i)"
                                                    [maxDate]="getFilterMaxEndDate(i)"
                                                    class="w-full">
                                                </p-datePicker>
                                            </div>
                                        </div>
                                        <div *ngIf="(filter.value.dataType != 13 && filter.value.dataType != 14)">
                                            <p-datePicker appendTo="body" [dateFormat]="defaultDateFormat" formControlName="value"
                                                [showIcon]="true" placeholder="Select Date" [showButtonBar]="true"
                                                class="w-full">
                                            </p-datePicker>
                                        </div>
                                    </div>
                                    <div class="w-full"
                                        *ngIf="[4,5,7].includes(getColumnInfo(filter.value.columnId).colDataType)">
                                        <p-multiSelect class="w-full" *ngIf="[15,16].includes(filter.value.dataType)"
                                            placeholder="Select" formControlName="value"
                                            [options]="getDropdownValues(i)" optionLabel="name" optionValue="code"
                                            [showClear]="filter.value.value ? true : false" [filter]="true" appendTo="body"></p-multiSelect>
                                        <p-select class="w-full" *ngIf="(![15,16].includes(filter.value.dataType))"
                                            placeholder="Select" formControlName="value"
                                            [options]="getDropdownValues(i)" optionLabel="name" optionValue="code"
                                            [showClear]="filter.value.value ? true : false" [filter]="true" appendTo="body"></p-select>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="flex justify-content-end col-10 p-0 mt-2">
                            <a class="blTxt" (click)="addApiFilterBlock()">Add Filters</a>
                        </div>
                    </div>
                </div>
                <div class="col-4 pr-0 pb-0 pt-0 pdL" *ngIf="saveReportFields">
                    <div class="mb-3">
                        <div class="sectLab1 mb-2">Report Security</div>
                        <div class="sectWB">
                            <div class="sectLab2 mb-3">View Access Configuration</div>
                            <div class="grid">
                                <div class="field col-6">
                                    <label>Role</label>
                                    <p-multiselect [options]="roleList" optionLabel="name"  optionValue="code" formControlName="viewRoleIds"
                                        placeholder="Select Role" [filter]="true" display="chip"  class="w-full" [disabled]="reportForm.get('viewToAll')?.value"
                                        (onChange)="onRoleChange($event)" class="w-full" appendTo="body" />
                                        <small class="p-error" style="font-size:12px" *ngIf="reportForm.get('viewRoleIds')?.invalid && reportForm.get('viewRoleIds')?.touched">
                                            Please select at least one role.
                                        </small>
                                </div>
                                <div class="field col-6">
                                    <label>Teams</label>
                                    <p-multiselect [options]="teamList" optionLabel="name" optionValue="code"
                                        formControlName="viewTeamIds" placeholder="Select Team" [filter]="true"
                                        display="chip" class="w-full dDRight" [disabled]="reportForm.get('viewToAll')?.value"
                                        (onChange)="onTeamChange($event)" appendTo="body" />
                                </div>

                            </div>
                            <div class="flex align-items-center">
                                <div class="field pr-3">
                                    <label>Allow access to all users</label>
                                </div>
                                <div class="field">
                                    <p-toggleswitch formControlName="viewToAll" (onChange)="changeViewAllAccess($event)"
                                        [(ngModel)]="viewAllAccess" />
                                </div>
                            </div>
                        </div>

                        <div class="sectWB">
                            <div class="sectLab2 mb-3">Edit Access Configuration</div>
                            <div class="grid">
                                <div class="field col-6">
                                    <label>Role</label>
                                    <p-multiselect [options]="editRoleList" optionLabel="name" optionValue="code"
                                        formControlName="editRoleIds" placeholder="Select Role" [filter]="true"
                                        class="w-full" [disabled]="reportForm.get('editToAll')?.value" class="w-full" appendTo="body" />
                                </div>
                                <div class="field col-6">
                                    <label>Teams</label>
                                    <p-multiselect [options]="editTeamList" optionLabel="name" optionValue="code"
                                        formControlName="editTeamIds" placeholder="Select Team" class="w-full dDRight"
                                        [filter]="true" [disabled]="reportForm.get('editToAll')?.value" appendTo="body" />
                                </div>
                            </div>
                            <div class="flex align-items-center">
                                <div class="field pr-3">
                                    <label>Allow access to all users</label>

                                </div>
                                <div class="field ">
                                    <p-toggleswitch formControlName="editToAll"
                                        (onChange)="changeeditAllAccess($event)" />
                                </div>
                            </div>
                            <div class="flex">
                                <div class="field pr-3">
                                    <label>Enable access based on hierarchy and reporting? <a class="m-0" href="javascript:void(0)" tooltipStyleClass="midTT"
                                        pTooltip="If the Toggle is ON irrespective of the permissions on the module security, data would be displayed based on the hirerachy and reporting to. The previously selected users list under the filter will not be applicable."
                                        tooltipPosition="bottom"><img src="assets/images/info-icon.svg" alt="" /></a></label>
                                </div>
                                <div class="field">
                                    <p-toggleswitch formControlName="enableHierarchySecurity" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <ng-template #footer>
            <div class="flex items-center gap-2">
                <button pButton label="Generate Report" (click)="onSubmit()"></button>
                <div *ngIf="showAllFields">
                    <button *ngIf="disableSaveReportButton() && checkUpdateReportPermission()" pButton label="Save Report" (click)="saveReport(false)"
                        class="mr-2"></button>
                    <button *ngIf="showSaveAsNewReportButton()" pButton label="Save as New Report"
                        (click)="saveReport(true)"></button>
                    <button *ngIf="showCreateSaveReportButton()" pButton label="Save Report"
                        (click)="saveReport(true)"></button>
                </div>
                <button pButton label="Cancel" (click)="hideGenerateReportForm()" [outlined]="true"
                    severity="secondary"></button>
            </div>
        </ng-template>
    </p-drawer>
</div>
<!-- Save Report popup end here -->